// Internal modules
import { appStore } from '@/store';
import { getGlobals } from '../globals';

export const useCheckInventorySoldout = (): any => {
  const { showSoldoutPage } =
    getGlobals().initialGqlData?.checkoutSession?.cart || {};

  if (showSoldoutPage) {
    appStore.getActions().ui.toggleIsInventorySoldOutOpen(true);
  }
};
